import { jsPDF } from 'jspdf';
import 'jspdf-autotable';

const DownloadAttendanceFullPdf = (detailData, companyName, logo, setOpenBackdrop, employeeName) => {
    if (!detailData || !detailData.punches) {
        alert("No punch data available!");
        return;
    }

    const doc = new jsPDF();
    setOpenBackdrop(true);

    try {
        // --- 1. Header Section ---
        if (logo) {
            doc.addImage(logo, 'PNG', 14, 10, 15, 15);
        }
        
        doc.setFontSize(16);
        doc.setTextColor(25, 118, 210);
        doc.setFont("helvetica", "bold");
        doc.text(companyName || 'COMPANY NAME', 35, 18);
        
        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.text('DETAILED ATTENDANCE LOG', 150, 18);

        doc.setLineWidth(0.5);
        doc.line(14, 28, 196, 28);

        // --- 2. Employee Info Section ---
        doc.setTextColor(0);
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");
        doc.text(`Employee Name :`, 14, 38);
        doc.setFont("helvetica", "normal");
        doc.text(`${employeeName || 'N/A'}`, 50, 38);

        doc.setFont("helvetica", "bold");
        doc.text(`Punch Date    :`, 14, 44);
        doc.setFont("helvetica", "normal");
        doc.text(`${detailData.punch_date || 'N/A'}`, 50, 44);

        doc.setFont("helvetica", "bold");
        doc.text(`Total Hours   :`, 130, 44);
        doc.setFont("helvetica", "normal");
        doc.text(`${detailData.total_working_hours || '00:00:00'}`, 160, 44);

        // --- 3. Punches Table ---
        const tableHeaders = [['S.No', 'Type', 'Punch Time', 'Site Name', 'Location (Lat, Long)']];
        
        // Sorting punches by time so they appear in order
        const sortedPunches = [...detailData.punches].sort((a, b) => 
            new Date(a.punch_time) - new Date(b.punch_time)
        );

        const tableData = sortedPunches.map((punch, idx) => [
            idx + 1,
            punch.type,
            punch.punch_time ? punch.punch_time.split(' ')[1] : 'N/A', // Sirf Time dikhane ke liye
            punch.site_name || 'N/A',
            `${punch.latitude}, ${punch.longitude}`
        ]);

        doc.autoTable({
            startY: 52,
            head: tableHeaders,
            body: tableData,
            theme: 'grid',
            headStyles: { fillColor: [25, 118, 210] },
            styles: { fontSize: 9 },
            columnStyles: {
                0: { cellWidth: 12 },
                1: { fontStyle: 'bold' }
            }
        });

        // --- 4. Footer ---
        const finalY = doc.lastAutoTable.finalY || 200;
        doc.setFontSize(8);
        doc.setFont("helvetica", "italic");
        doc.setTextColor(150);
        doc.text("This is a computer generated attendance log.", 105, 285, { align: 'center' });

        doc.save(`${employeeName}_Attendance_${detailData.punch_date}.pdf`);

    } catch (error) {
        console.error("PDF Error:", error);
        alert("Error generating PDF");
    } finally {
        setOpenBackdrop(false);
    }
};

export default DownloadAttendanceFullPdf;